<template>
  <div id="payments-schedule-page" class="viewport viewport-with-top-nav viewport-compact">

    <TopNav></TopNav>

    <div class="display-1 py-3">{{ $t('LoanPaymentSchedulePage.paymentsSchedule') }}</div>
    <div v-if="loan == null">
      <div class="card card-shadow card-rounded border-0 mb-4">
        <div class="card-body py-5 text-center">
          <spinner></spinner>
        </div>
      </div>
    </div>
    <template v-else>
      <SendDocumentForm :reference="loan.reference" type="installments"/>

      <div class="row">
        <div class="col-6 form-group">
          <div class="small text-muted">{{ $t('LoanPaymentSchedulePage.referenceNumber') }}</div>
          <strong>{{loan.reference}}</strong>
        </div>
        <div class="col-6 form-group">
          <div class="small text-muted">{{ $t('LoanPaymentSchedulePage.totalToBePaid') }}</div>
          <strong>{{ $n(loan.totalDebt, 'currency') }}</strong>
        </div>
      </div>

      <div class="row">
        <div class="col-6 form-group">
          <div class="small text-muted">{{ $t('LoanPaymentSchedulePage.payments') }}</div>
          <strong>{{loan.periodInMonths}}/{{loan.paidInstallmentsCount}}</strong>
        </div>
        <div class="col-6 form-group">
          <div class="small text-muted">{{ $t('LoanPaymentSchedulePage.remainingBalance') }}</div>
          <strong>{{ $n(loan.remainingAmount, 'currency') }}</strong>
        </div>
      </div>

      <div v-if="loan.installments.length > 0">
        <table class="table table-escape-container bg-container">
          <tbody>
          <template v-for="(installment, index) in loan.installments">
            <tr :key="index">
              <td class="text-muted">
                {{ $d(installment.date) }}
                <div class="small text-warning" v-if="installment.inDelay">{{$t('LoanPaymentSchedulePage.paymentOverdue')}}</div>
                <div class="small text-warning" v-if="installment.suspendedUntil">
                  {{ $t('LoanPaymentSchedulePage.suspendedUntil', {suspendedUntil: $d(installment.suspendedUntil)}) }}
                </div>
              </td>
              <td class="text-right text-amount">
                <div :class="{
                    'text-success': installment.paid,
                    'text-warning': installment.inDelay && !isPaidPartially(installment),
                    'text-muted-more': isPaidPartially(installment)
                  }">{{ $n(installment.amount, 'currency') }}</div>

                <div v-if="installment.suspendable">
                  <router-link :to="{ name: 'loan-request-suspension', params: { reference: loan.reference }}" class="d-inline-flex align-items-center small">
                    <span>{{ $t('LoanPaymentSchedulePage.suspendInstallment') }}</span>
                    <Icon icon-name="arrow-ios-forward-outline" class="icon-xs"></Icon>
                  </router-link>
                </div>

                <div class="small text-danger" v-if="installment.penaltiesAmount > 0">
                  {{ $t('LoanPaymentSchedulePage.penalties', {penaltiesAmount: $n(installment.penaltiesAmount, 'currency') }) }}
                </div>
                <div class="small text-danger" v-if="installment.suspensionFee > 0">
                  {{ $t('LoanPaymentSchedulePage.suspensionFee', {suspensionFee: $n(installment.suspensionFee, 'currency') }) }}
                </div>
                <div class="" v-if="isPaidPartially(installment) || installment.penaltiesAmount > 0">
                  <div class="small text-muted" v-if="installment.paidAmount > 0">{{ $t('LoanPaymentSchedulePage.totalPaid', {paidAmount: $n(installment.paidAmount, 'currency') }) }}</div>
                  <div class="text-warning">{{ $t('LoanPaymentSchedulePage.totalUnpaid', {unpaidAmount: $n(installment.unpaidAmount, 'currency') }) }}</div>
                </div>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </template>

    <div class="flex-grow-1"></div>

  </div>
</template>

<script>
import TopNav from '@shared/components/TopNav'
import Icon from '@shared/components/Icon'
import SendDocumentForm from '@shared/components/SendDocumentForm'
import store from '@shared/store'

export default {
  name: 'LoanPaymentSchedulePage',
  components: {
    Icon,
    TopNav,
    SendDocumentForm
  },
  data() {
    return {
      loan: null,
      reference: this.$route.params.id,
      onRouteLeave: false
    }
  },
  mounted() {
    if (this.$configuration.newCoreEnabled) {
      this.$router.replace({
        name: 'nc-loan-payment-schedule',
        params: this.$route.params
      })
    } else {
      this.fetchLoanById(this.$route.params.id)
      store.requireToShowPaymentScheduleSurvey()
    }
  },
  methods: {
    isPaidPartially(installment) {
      return installment.unpaidAmount !== installment.amount && installment.unpaidAmount > 0
    },
    fetchLoanById() {
      return this.$http.get(`/api/loans/${this.reference}/installments`)
          .then(response => {
            this.loan = response.data
          })
    }
  }
}
</script>
